module.exports = __webpack_public_path__ + "img/private-key-grey.f8cb5fc5.svg";